import { LicenseCode, LicenseTypes } from '../../types/licenses';
import { createBackgroundTheaterDefaults } from '../business-information/forms/backgroundTheater.Schema';
import { createChoirDefaults } from '../business-information/forms/choir.Schema';
import { createChurchDefaults } from '../business-information/forms/church.Schema';
import { createCinemaDefaults } from '../business-information/forms/cinema.Schema';
import { createCompanyPartyDefaults } from '../business-information/forms/companyParty.Schema';
import { createConcertAndEventDefaults } from '../business-information/forms/concertAndEvent.Schema';
import { createDanceSchoolDefaults } from '../business-information/forms/danceSchool.Schema';
import { createFitnessCenterDefaults } from '../business-information/forms/fitness.Schema';
import { createFootballDefaults } from '../business-information/forms/football.Schema';
import { createGymnasticsDefaults } from '../business-information/forms/gymnastics.Schema';
import { createHandballDefaults } from '../business-information/forms/handball.Schema';
import { createIceHockeyAndVolleyballDefaults } from '../business-information/forms/iceHockeyAndVolleyball.Schema';
import { createMusicOnPhoneLinesDefaults } from '../business-information/forms/musicOnPhoneLines.Schema';
import { createPodcastDefaults } from '../business-information/forms/podcast.Schema';
import { createRecreationalRunsDefaults } from '../business-information/forms/recreationalRuns.Schema';
import { createRestaurantAndCafeDefaults } from '../business-information/forms/restaurantAndCafe.Schema';
import { createShopAndServiceIndustryDefaults } from '../business-information/forms/shopAndServiceIndustry.Schema';
import { createSportsEventsAndTournamentsDefaults } from '../business-information/forms/sportsEventsAndTournaments.Schema';
import { createTheaterBusinessInformationDefaults } from '../business-information/forms/theater.Schema';
import { BusinessInformation } from '../business-information/forms/types/businessInformation';
import { createTheaterInitialInformationDefaults } from '../initial-information/theater.Schema';

export const businessInformationDefaultsByLicense: Partial<Record<LicenseCode, () => BusinessInformation>> = {
  [LicenseTypes.ShopAndServiceIndustry]: createShopAndServiceIndustryDefaults,
  [LicenseTypes.RestaurantAndCafe]: createRestaurantAndCafeDefaults,
  [LicenseTypes.ConcertAndEvent]: createConcertAndEventDefaults,
  [LicenseTypes.Cinema]: createCinemaDefaults,
  [LicenseTypes.Theater]: createTheaterBusinessInformationDefaults,
  [LicenseTypes.BackgroundTheater]: createBackgroundTheaterDefaults,
  [LicenseTypes.Church]: createChurchDefaults,
  [LicenseTypes.Choir]: createChoirDefaults,
  [LicenseTypes.FitnessCenterAndTreatment]: createFitnessCenterDefaults,
  [LicenseTypes.Football]: createFootballDefaults,
  [LicenseTypes.DanceSchool]: createDanceSchoolDefaults,
  [LicenseTypes.Gymnastics]: createGymnasticsDefaults,
  [LicenseTypes.IceHockeyAndVolleyball]: createIceHockeyAndVolleyballDefaults,
  [LicenseTypes.Handball]: createHandballDefaults,
  [LicenseTypes.SportsEventsAndTournaments]: createSportsEventsAndTournamentsDefaults,
  [LicenseTypes.RecreationalRuns]: createRecreationalRunsDefaults,
  [LicenseTypes.Podcast]: createPodcastDefaults,
  [LicenseTypes.MusicOnPhoneLines]: createMusicOnPhoneLinesDefaults,
  [LicenseTypes.CompanyParty]: createCompanyPartyDefaults,
};

export const initialInformationDefaultsByLicense: Partial<Record<LicenseCode, () => BusinessInformation>> = {
  [LicenseTypes.Theater]: createTheaterInitialInformationDefaults,
};

export const bootstrapLicense = (licenseCode: LicenseCode): BusinessInformation => {
  const businessDefaults = businessInformationDefaultsByLicense[licenseCode]?.() ?? { licenseCode };
  const initialDefaults = initialInformationDefaultsByLicense[licenseCode]?.() ?? {};

  return {
    ...businessDefaults,
    ...initialDefaults,
  };
};
